import { render, staticRenderFns } from "./ProposalListItem.vue?vue&type=template&id=0e78885a&scoped=true"
import script from "./ProposalListItem.vue?vue&type=script&lang=js"
export * from "./ProposalListItem.vue?vue&type=script&lang=js"
import style0 from "./ProposalListItem.vue?vue&type=style&index=0&id=0e78885a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e78885a",
  null
  
)

export default component.exports